import { Container, Col, Row } from "reactstrap";
import * as SitePackQL from "queries/site-pack";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import SitePackSchema from "@common/schema/site-pack/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

// Hoisted for the reason recorded in ../pack/edit: a config literal is a new
// object every render and the provider rebuilds underneath it.
//
// `status` is on the listing and is the column that earns its place: a pack
// with no archive yet is PENDING and answers nothing, and gen-2's list — which
// showed a name, a route and an external-link icon and nothing else — made
// that state indistinguishable from a live mount. `fileId` is deliberately not
// here: it is an opaque id, and the row it names is one click away.
const LIST_FIELDS = {
  "/Public/SitePack": {
    fields: ["packId", "route", "type", "status", "updatedAt"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.sites.get.packs"}
        query={SitePackQL.list}
        variables={params}
        schema={SitePackSchema}
        widgets={widgets}
        target={{ $ref: "/Public/SitePack" }}
        empty={"No route packs yet."}
        config={LIST_FIELDS}
        content={({ item: { packId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${packId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
